@if (form) {
  <mat-card>
    <app-card-header
      [title]="data.estado || data.estadoTecnico || 'Agregar nota'"
      [subtitle]="'Agregar información al tratamiento'"
      icono="note"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Nota -->
        <section class="inputs-group">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nota</mat-label>
            <textarea
              matInput
              formControlName="nota"
              rows="4"
              placeholder="Ingresá una nota visible para el cliente..."
              aria-label="Nota del tratamiento"
            ></textarea>
            <mat-hint>Esta nota será visible para el cliente</mat-hint>
          </mat-form-field>
        </section>

        <!-- Nota Interna -->
        <section class="inputs-group">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nota Interna</mat-label>
            <textarea
              matInput
              formControlName="notaInterna"
              rows="4"
              placeholder="Ingresá una nota interna privada..."
              aria-label="Nota interna del tratamiento"
            ></textarea>
            <mat-hint>Esta nota es solo para uso interno</mat-hint>
          </mat-form-field>
        </section>

        <!-- Reactivar dispositivo (solo al finalizar con modo desactivado vigente) -->
        @if (mostrarReactivar) {
          <section class="inputs-group">
            <mat-checkbox
              [(ngModel)]="reactivarDispositivo"
              [ngModelOptions]="{ standalone: true }"
            >
              Reactivar dispositivo al finalizar
            </mat-checkbox>
          </section>
        }
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!this.form.valid || loading"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
